module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "safari-share.c8a20fc8.png";